import { render, staticRenderFns } from "./InputPriceFromTo.vue?vue&type=template&id=54a25d4b&scoped=true"
import script from "./InputPriceFromTo.vue?vue&type=script&lang=js"
export * from "./InputPriceFromTo.vue?vue&type=script&lang=js"
import style0 from "./InputPriceFromTo.vue?vue&type=style&index=0&id=54a25d4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a25d4b",
  null
  
)

export default component.exports